module.exports = __webpack_public_path__ + "static/hero4-6bf7715088dcc1f931126cbfb5e18f11.jpg";